const renderCatalogTooltips = () => {
  
  const catalogInfoContainer = document.querySelectorAll('.catalog-row__info');
  
  if (catalogInfoContainer) {
    catalogInfoContainer.forEach((el) => {
      const button = el.querySelector('.catalog-row__info-button');
      const tooltip = el.querySelector('.catalog-row__info-tooltip');
    
      const showTooltip = () => {
        tooltip.classList.remove('catalog-row__info-tooltip--hidden')
      }
      
      const hideTooltip = () => {
        tooltip.classList.add('catalog-row__info-tooltip--hidden')
      }
      
      if (button) {
        button.addEventListener('mouseenter', showTooltip)
        button.addEventListener('focus', showTooltip)
      
        button.addEventListener('mouseleave', hideTooltip)
        button.addEventListener('blur', hideTooltip)
      
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            hideTooltip()
          }
        })
      };
  
    });
  }
};

export {renderCatalogTooltips};